import React from 'react'
import SelectField from 'material-ui-legacy/SelectField'
import MenuItem from 'material-ui-legacy/MenuItem'

const ValueTypeSelect = (props) => (
  <SelectField
    name='valueType'
    floatingLabelText="Type of value (required)"
    fullWidth={props.fullWidth}
    style={props.style}
    value={props.value}
    onChange={props.onChange}
    required
  >
    <MenuItem
      value='dollar_value'
      primaryText='Dollar value'
    />
    <MenuItem
      value='added_percentage'
      primaryText='Added percentage (60% = 1.60)'
    />
    <MenuItem
      value='percentage_of'
      primaryText='Percentage of (60% = 0.60)'
    />
  </SelectField>
)

export default ValueTypeSelect



// WEBPACK FOOTER //
// ./src/components/ReferenceValues/ValueTypeSelect.jsx